import React from 'react';
import { Link } from 'react-router-dom';

const CampaignList = ({ campaigns, getStatusColor, onCampaignUpdate }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDateRange = (startDate, endDate) => {
    const start = formatDate(startDate);
    const end = endDate ? formatDate(endDate) : 'Ongoing';
    return `${start} - ${end}`;
  };

  const getCampaignStatus = (campaign) => {
    const now = new Date();
    const startDate = new Date(campaign.scheduledTime);
    const endDate = campaign.endTime ? new Date(campaign.endTime) : null;

    if (endDate && now > endDate) {
      return 'Completed';
    } else if (now >= startDate && (!endDate || now <= endDate)) {
      return 'Live';
    } else if (now < startDate) {
      return 'Scheduled';
    }
    return 'Unknown';
  };

  const canEditCampaign = (campaign) => {
    const now = new Date();
    const startDate = new Date(campaign.scheduledTime);
    return now < startDate;
  };

  const canAddMessages = (campaign) => {
    const now = new Date();
    const startDate = new Date(campaign.scheduledTime);
    const endDate = campaign.endTime ? new Date(campaign.endTime) : null;
    
    return now >= startDate && (!endDate || now <= endDate);
  };

  return (
    <div className="overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Campaign Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Timeline
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {campaigns.map((campaign) => {
            const status = getCampaignStatus(campaign);
            const statusColor = getStatusColor(status);
            const canEdit = canEditCampaign(campaign);
            const canAddMsg = canAddMessages(campaign);

            return (
              <tr key={campaign.campaignId} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <Link 
                    to={`/campaigns/${campaign.campaignId}`} 
                    className="text-sm font-medium text-blue-600 hover:text-blue-900"
                  >
                    {campaign.campaignName}
                  </Link>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {formatDateRange(campaign.scheduledTime, campaign.endTime)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span 
                    className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white"
                    style={{ backgroundColor: statusColor }}
                  >
                    {status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex items-center justify-end space-x-2">
                    <Link 
                      to={`/campaigns/${campaign.campaignId}`} 
                      className="text-gray-600 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                    >
                      View Details
                    </Link>
                    
                    {canEdit && (
                      <Link 
                        to={`/campaigns/${campaign.campaignId}/edit`} 
                        className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                      >
                        Edit
                      </Link>
                    )}
                    
                    {canAddMsg && (
                      <Link 
                        to={`/campaigns/${campaign.campaignId}/messages/new`} 
                        className="text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                      >
                        + Message
                      </Link>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignList;
